/** saves Accounts Balances
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCE = (state, payload) => {
	state.accountsBalances = payload.balanceViews
}

/**
@payload { Array }
*/
export const SAVE_ACCOUNT_ALIAS = (state, payload) => {
	state.accountAlias = payload.aliases
    state.smsPhoneNumber = payload.smsPhoneNumber
}

/**
@payload { Object }
*/
export const SAVE_CUSTOMER = (state, payload) => {
	state.customer = payload
}

export const SAVE_ACCOUNTS_PLAFOND = (state, payload) => {
	state.plafond = payload
}

export const SAVE_ACCOUNTS_TRANSACTION_LIMIT = (state, payload) => {
	state.transactionLimit = payload
}
/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
	state.cardsList = []
    state.accountAlias = []
    state.customer = {}
    state.plafond = []
    state.transactionLimit = []
}
